import {useTrackFeature} from '@aboutyou/tracking';
import {useCallback} from 'react';

export const useTrackRecoFeatureClick = ({
  featureLabel,
  genericLabel,
}: {
  featureLabel?: string;
  genericLabel?: string;
}) => {
  const trackFeature = useTrackFeature();
  return useCallback(() => {
    if (genericLabel) {
      trackFeature({eventType: 'click', label: genericLabel});
    }
    if (featureLabel) {
      trackFeature({eventType: 'click', label: featureLabel});
    }
  }, [featureLabel, genericLabel, trackFeature]);
};
